export default {
    "savedQueries": {
        "savedQueries": "Requêtes sauvegardées",
        "saveCurrentQuery": "Enregistrer la requête courante",
        "manageSavedQueries": "Gérer les requêtes sauvegardées",
        "savedQueryAlreadyExists": "Une requête sauvegardée avec ce nom existe déjà. Voulez-vous la remplacer ?",
        "noSavedQuery": "Vous n'avez pas encore enregistré de requête de recherche...",
        "delete": "Supprimer cette requête enregistrée"
    },

    "recentQueries": {
        "noRecentQuery": "Vous n'avez pas encore effectué de recherche...",
        "delete": "Supprimer cette requête",
        "save": "Enregistrer cette requête"
    },

    "recentDocuments": {
        "recentDocuments": "Documents récents",
        "noRecentDocument": "Vous n'avez pas encore ouvert de document...",
        "delete": "Supprimer ce document récent"
    },

    "editSavedQuery": {
        "title": "Requête sauvegardée",
        "name": "Nom"
    },

    "exportQuery": {
        "dialogTitle": "Export",
        "dialogOutputFormat": "Format de sortie",
        "dialogMaxCount": "Nb max de lignes",
        "dialogSourceType": "Exporter depuis",
        "dialogResult": "Résultat courant",
        "dialogSelection": "Sélection courante",
        "btnTitle": "Exporter les résultats",
        "exportResult": "Exporter le résultat en {type}",
        "exportSelection": "Exporter la sélection en {type}",
        "btnDownload": "Télécharger",
        "btnClose": "Fermer",
        "successNotification": "Téléchargement terminé",
        "exportedColumns": "Colonnes à exporter",
        "exportedColumnsLabelTooltip": "Sélectionnez les colonnes que vous souhaitez exporter, une sélection vide signifie la sélection de tous le colonnes",
        "dialogMaxCountTooltip": "Par défaut, le nombre de résultats est limité à {count}"
    },

    "manageSavedQueries": {
        "title": "Gérer les requêtes sauvegardées",
        "save": "Enregistrer",
        "reorder": "Réorganiser",
        "remove": "Effacer",
        "removeAll": "Effacer tout",
        "export": "Exporter",
        "name": "Nom",
        "rss": "Flux RSS"
    },

};
